import { forwardRef } from 'react'

import { Spinner } from '../Spinner'
import styles from './LoadingOverlay.module.css'

export interface LoadingOverlayProps extends React.HTMLAttributes<HTMLDivElement> {
  /** 是否显示 */
  visible?: boolean
  /** 主要文字 */
  text?: string
  /** 次要文字（提示） */
  subtext?: string
  /** Spinner 大小 */
  spinnerSize?: 'sm' | 'md' | 'lg'
}

export const LoadingOverlay = forwardRef<HTMLDivElement, LoadingOverlayProps>(
  ({ visible = true, text, subtext, spinnerSize = 'lg', className, ...props }, ref) => {
    if (!visible) {
      return null
    }

    const classNames = [styles.overlay, className].filter(Boolean).join(' ')

    return (
      <div
        ref={ref}
        className={classNames}
        role="alert"
        aria-busy="true"
        data-ga-module="loading"
        {...props}
      >
        <div className={styles.content}>
          <Spinner size={spinnerSize} />
          {text && <p className={styles.text}>{text}</p>}
          {subtext && <p className={styles.subtext}>{subtext}</p>}
        </div>
      </div>
    )
  }
)

LoadingOverlay.displayName = 'LoadingOverlay'
